import { render, staticRenderFns } from "./leaveDialog.vue?vue&type=template&id=2dfb8f30&scoped=true"
import script from "./leaveDialog.vue?vue&type=script&lang=js"
export * from "./leaveDialog.vue?vue&type=script&lang=js"
import style0 from "./leaveDialog.vue?vue&type=style&index=0&id=2dfb8f30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfb8f30",
  null
  
)

export default component.exports